module.exports = __webpack_public_path__ + "static/media/upload-document-ruledpage-desktop.31cae941.png";